import { agent } from './agent';

export interface AuditLogEntry {
  id: number;
  createdAt: string;
  actioningUserId: string;
  actioningUserName: string;
  affectedUserId: string;
  affectedUserName: string;
  action: string;
  source?: string;
  targetEntityType?: string;
  targetEntityId?: string;
  summary?: string;
  details?: string;
}

export interface AuditLogResponse {
  entries: AuditLogEntry[];
  page: number;
  hasMore: boolean;
  totalEntries: number;
}

export interface AuditLogQuery {
  page: number;
  action?: string;
  category?: string;
  source?: string;
  search?: string;
}

export async function requestAuditLogs(query: AuditLogQuery): Promise<AuditLogResponse> {
  const params = new URLSearchParams();
  params.set('page', String(query.page));
  if (query.action) params.set('action', query.action);
  if (query.category) params.set('category', query.category);
  if (query.source) params.set('source', query.source);
  if (query.search) params.set('search', query.search);
  return await agent.requests.get(`/api/company/audit-log?${params.toString()}`);
}
